function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLight198X198Px = function SvgLight198X198Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 198 198",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m115.7 6.6 76.5 81c7.5 8 7.2 20.5-.8 28.1l-81 76.5c-8 7.5-20.5 7.2-28.1-.8l-76.5-81c-7.5-8-7.2-20.5.8-28.1l81-76.5c8-7.5 20.6-7.1 28.1.8",
    style: {
      fill: "#f0f4f9"
    }
  }));
};
export default SvgLight198X198Px;